module.exports = __webpack_public_path__ + "static/manhattan-bridge-zoom-5b9b41df2fba0949dbdb917bc08ec431.jpg";